<template>
  
    <div >
      <packagesisps
        :isloading="isLoading"
        :activepackagesisps="activePackagesIsps"
        :archivedpackagesisps="archivedPackagesIsps"
        :unregisteredpackagesisps="unregisteredPackagesIsps"
        :speedprofiles="speedProfiles"
        :filterspeeds="filterSpeeds"
        :packagesispcats="packagesIspCats"
        :packagesisptemplates="packagesIspTemplates"
        :locationnetworks="locationNetworks"
        :packagetypes="['Residential', 'Business','Other']"
        :organisations="organisations"
        :layertwousage="layerTwoUsage"
        :packageOverview="packageOverview"
        @packagesIspsSaved="refreshIspPackages();"
        @groupTemplateChange="updateGroupTemplate()"
      ></packagesisps>
    </div>

</template>
      <!-- ///////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
<script>
import Api from "@/services/Api";
import format from "date-fns/format";

import PackagesIsps from '@/components/OwnPackagesIsps.vue';
import ActivePackagesIsps from '@/components/PackagesIsps.vue';
import ArchivedPackagesIsps from '@/components/PackagesIsps.vue';
import UnregisteredPackagesIsps from '@/components/PackagesIsps.vue';
import LocationNetworks from '@/components/PackagesIsps.vue';
export default {
    
  components: {
    packagesisps: PackagesIsps,
    activepackagesisps: ActivePackagesIsps,
    archivedpackagesisps: ArchivedPackagesIsps,
    unregisteredpackagesisps: UnregisteredPackagesIsps,
    locationnetworks: LocationNetworks

  },
  data() {
    return {
      LocationNetworksLocations: [],
      speedProfiles:[],
      packagesIsp:[],
      packagesIspCats:[],
      packageOverview: [],
      packagesIspTemplates:[],
    activePackagesIsps:[],
    archivedPackagesIsps: [],
    unregisteredPackagesIsps: [],
    customerId:[],
    filterSpeeds:[],
    isLoading: true,
    locationNetworks: [],
    organisations: [],
    initialActivePackagesIsps:[],
    initialArchivedPackagesIsps: [],
    initialUnregisteredPackagesIsps: [],
    layerTwoUsage: [],
    };
  },
  computed: {},
  async created() {
      if (this.authRead(this.$store.state.currentRoute) === true) {
        this.initialize();
      }
  },
  watch: {
    activepackagesisps: ()=> {
      this.activepackagesisps = fetchLocations();
    },
    '$route.query':{
      immediate: true,
      async handler(value){
        this.isLoading=true
        
        if(typeof value.locationNetworkId ==='undefined'){
          value.locationNetworkId=null
        } 
        if(typeof value.customerId ==='undefined'){
          value.customerId=null
        }
        if(typeof value.speedProfileId ==='undefined'){
          value.speedProfileId=null
        }
        if(typeof value.packageType ==='undefined'){
          value.packageType=null
        }
      
        let customerId=value.customerId
        let locationNetworkId = value.locationNetworkId
        let speedProfileId = value.speedProfileId
        let packageType=value.packageType
          this.activePackagesIsps=this.initialActivePackagesIsps
          
          if(customerId!==null){
            this.activePackagesIsps= await this.activePackagesIsps.filter(function(el){
              return el.customerId ===customerId
            })
          }
          if(locationNetworkId!==null){
            this.activePackagesIsps=await this.activePackagesIsps.filter(function(el){
              return el.locationNetworkId ===locationNetworkId
            })
          }
          if(speedProfileId!==null){
            this.activePackagesIsps=await this.activePackagesIsps.filter(function(el){
              return el.packagesFno.speedProfile.downloadMbps ===speedProfileId
            })
          }
          if(packageType!==null){
            this.activePackagesIsps=await this.activePackagesIsps.filter(function(el){
              return el.packagesFno.packagesFnoCat.packageCatType ===packageType
            })
          }
        this.isLoading=false
        }
       
  }
  },

  methods: {
      fetchOrganisations() {
      this.isLoading =true
      Api()
        .get("/organisation/basic")
        .then(response => {
          this.organisations = response.data;
              this.isLoading =false
        });
    },
  async refreshIspPackages(){
        this.isLoading=true
        await this.fetchAllPackagesIsps()
        
        if(typeof this.$route.query.locationNetworkId ==='undefined'){
          this.$route.query.locationNetworkId=null
        } 
        if(typeof this.$route.query.customerId ==='undefined'){
          this.$route.query.customerId=null
        }
        if(typeof this.$route.query.speedProfileId ==='undefined'){
          this.$route.query.speedProfileId=null
        }
        if(typeof this.$route.query.packageType ==='undefined'){
          this.$route.query.packageType=null
        }
        let customerId=this.$route.query.customerId
        let locationNetworkId = this.$route.query.locationNetworkId
        let speedProfileId = this.$route.query.speedProfileId
        let packageType=this.$route.query.packageType
        if(this.$route.currentTab==='activePackages'){
          this.activePackagesIsps=this.initialActivePackagesIsps
          if(customerId!==null){
            this.activePackagesIsps= await this.activePackagesIsps.filter(function(el){
              return el.customerId ===customerId
            })
          }
          if(locationNetworkId!==null){
            this.activePackagesIsps=await this.activePackagesIsps.filter(function(el){
              return el.locationNetworkId ===locationNetworkId
            })
          }
          if(speedProfileId!==null){
            this.activePackagesIsps=await this.activePackagesIsps.filter(function(el){
              return el.packagesFno.speedProfileId ===speedProfileId
            })
          }
          if(packageType!==null){
            this.activePackagesIsps=await this.activePackagesIsps.filter(function(el){
              return el.packagesFno.packagesFnoCat ===packageType
            })
          }
        }
        this.isLoading=false
    },
      async fetchAllPackagesIsps() {
        this.isLoading=true
        let locationNetworkId=[]
        this.locationNetworks=[]
        this.packageOverview=[]
        let packages = []
      await Api()
        .get("/customer/packagesIsps/basic/active")
        .then(response => {
          this.activePackagesIsps = response.data;
          this.initialActivePackagesIsps=response.data
          this.isLoading=false
        });
        await Api()
        .get('/customer/ispLocationNetwork')
        .then(async response=>{
          for (let i=0;i< response.data.length;i++){
            if(!locationNetworkId.includes(response.data[i].locationNetworkId)){
            await locationNetworkId.push(response.data[i].locationNetworkId)
            await this.locationNetworks.push(response.data[i].locationNetwork)
            }
              await packages.push({locationNetworkId: response.data[i].locationNetworkId, packagesFno: response.data[i].packagesFno, ispLocationNetworkId: response.data[i].id})
            }
        })
        for (let b=0; b<this.locationNetworks.length;b++){
          
          let id =this.locationNetworks[b].id
          let availablePackages = await packages.filter(function(el){
            return el.locationNetworkId === id &&
                  el.packagesFno.isActive===true&&
                  el.packagesFno.isDeleted===false
          })
          availablePackages = availablePackages.filter((item, index, self) =>
  index === self.findIndex((t) => (
    t.packagesFno.id === item.packagesFno.id && t.locationNetworkId === item.locationNetworkId
  ))
)
          let currentPackages = await this.initialActivePackagesIsps.filter(function(el){
            return el.locationNetworkId ===id&&
            el.isActive===true&&
            el.isVerified===true
          })
          let currentFnoPackages=[]
          for(let a=0; a< currentPackages.length;a++){
            await currentFnoPackages.push(currentPackages[a].packagesFnoId)
          }
          let unusedPackages=[]
          this.locationNetworks[b].availablePackages=availablePackages
          for(let x=0;x<availablePackages.length;x++){
            
            if(!currentFnoPackages.includes(availablePackages[x].packagesFno.id)){
              if(!unusedPackages.includes(availablePackages[x].packagesFno)){
                await unusedPackages.push(availablePackages[x].packagesFno)
              }
            }
          }
          this.locationNetworks[b].currentPackages=currentPackages
          this.locationNetworks[b].unusedPackages=unusedPackages
        }
        this.locationNetworks.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
        },
        fetchAllLocationNetworks(){
      Api()
        .get("/locationNetworks/basic/active")
        .then(response => {
          this.locationNetworks = response.data;
          this.isLoading=false
        });
        },
        fetchSpeedProfiles(){
          this.filterSpeeds=[]
          Api()
          .get('/speedProfiles')
          .then(response=>{
            this.speedProfiles=response.data
            this.filterSpeeds = [
            ...new Set(
              this.speedProfiles.map(
                item => item.downloadMbps
              )
            )
          ];
            // for(let i=0;i<this.speedProfiles.length;i++){
            //   if(!this.filterSpeeds.includes(this.speedProfiles[i].downloadMbps)){
            //     this.filterSpeeds.push(this.speedProfiles[i].downloadMbps)
            //   }
            // }
            this.filterSpeeds.sort((a, b) => a - b);
          })
        },
    fetchLocations(){
      Api()
        .get("/Locations/active")
        .then(response => {
          this.LocationNetworksLocations = response.data;
        })
    },
    fetchPackagesIspCats(){
      Api()
      .get('/packagesIspCats')
      .then(response=>{
        this.packagesIspCats=response.data
      })
    },
    async fetchPackagesIspTemplate(){
      await Api()
      .get('/customer/packagesIspTemplate')
      .then(response=>{
        this.packagesIspTemplates=response.data
      })
    },
    fetchPackagesIspCatsByCustomer(ispId){
      Api()
      .get('/packagesIspCats/byCustomer/'+ispId)
      .then(response=>{
        this.packagesIspCats=response.data
      })
    },
    fetchPackagesIspTemplateByCustomer(ispId){
      Api()
      .get('/packagesIspTemplate/byCustomer')
      .then(response=>{
        this.packagesIspTemplates=response.data
      })
    },
    updateGroupTemplate(){
          this.fetchPackagesIspCats();
          this.fetchPackagesIspTemplate()
    },
    async fetchLayerTwoBills(){
      await Api()
        .get('/libre/customer/billHistory/'+this.$store.state.currentOrg.org.libreBillId)
        .then(response=>{
          this.layerTwoUsage=response.data.bill_history
        })
    },
    async initialize() {
        this.fetchSpeedProfiles();
        await this.fetchAllPackagesIsps();
              // this.fetchPackagesIspCatsByCustomer(this.$store.state.customerId);
              this.fetchPackagesIspTemplate()
              if(this.$store.state.currentOrg.org.libreBillId!==null){
                this.fetchLayerTwoBills()
              }
              // this.fetchOrganisations()
    }
  }
};
</script>
